import { MenuItem, Select, type SelectChangeEvent } from "@mui/material";
import type { FC } from "react";
import {
  filterFieldOperators,
  mapOperator,
  type TextOperator,
} from "../../../segment-operation/operators";
import type { Condition } from "../../types";

export const AutocompleteOpSelect: FC<{
  condition: Condition;
  handleFieldChange: (value: Partial<Condition>) => void;
  disabled?: boolean;
  fieldType: "TEXT" | "COUNTRY";
}> = ({ condition, handleFieldChange, disabled, fieldType }) => {
  return (
    <Select
      variant="outlined"
      fullWidth
      label="Operator"
      size="small"
      onChange={(event: SelectChangeEvent) => {
        const value = event.target.value as TextOperator;
        const isEmpty = value === "IS BLANK" || value === "IS NOT BLANK";
        handleFieldChange({
          invert: !(value === "IS" || value === "IS BLANK"),
          operation: isEmpty ? "IS EMPTY" : "IS",
          values: isEmpty ? [] : condition.values,
        });
      }}
      labelId="operator-label"
      value={mapOperator(condition)}
      disabled={disabled}
    >
      {filterFieldOperators[fieldType].operators.map((operatorInfo) => (
        <MenuItem key={operatorInfo.operator} value={operatorInfo.operator}>
          {operatorInfo.label()}
        </MenuItem>
      ))}
    </Select>
  );
};
